import { defineStore } from "pinia";
import { v4 } from "uuid";

type LoadingState = Record<string, string[]>;

export const useLoading = defineStore("loading", {
  state: (): LoadingState => ({
    map: [],
    accumulations: [],
    locationAccumulations: [],
    default: [],
    table: [],
    "record-update": [],
  }),
  actions: {
    registerRequest(type: string): string {
      const id = v4();
      if (this[type]) {
        this[type].push(id);
      } else {
        this[type] = [id];
      }
      return id;
    },
    unregisterRequest<T>(id: string, result: T, type: string): Promise<T> {
      this[type] = this[type].filter((s) => s !== id);
      return Promise.resolve(result);
    },
    handleRequest<T>(
      cb: Promise<T>,
      queue = "default",
      fallbackData = {} as T
    ): Promise<T> {
      const id = this.registerRequest(queue);
      return cb
        .then((r) => this.unregisterRequest(id, r, queue))
        .catch(() => this.unregisterRequest(id, fallbackData, queue));
    },
  },
  getters: {
    isLoadingData(): (queue: string) => boolean {
      return (queue) => Boolean(this[queue]?.length);
    },
  },
});
